import * as React from 'react'
import { ActionIcon } from '@mantine/core'

// 救灾物资储备库
const SvgComponent = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 22 26"
    className="design-iconfont"
    width={width}
    height={height}
  >
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="5kaqpokcm__4b4lub4d2b"
      >
        <stop stopColor="#F9945B" offset="0%" />
        <stop stopColor="#F97241" offset="47.123%" />
        <stop stopColor="#F94B23" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="5kaqpokcm__c5d6t9hzja"
      >
        <stop stopColor="#FFB083" offset="0%" />
        <stop stopColor="#FF7A5C" offset="100%" />
      </linearGradient>
      <filter
        x="-95.6%"
        y="-45.5%"
        width="291.2%"
        height="227.5%"
        filterUnits="objectBoundingBox"
        id="5kaqpokcm__ucgztkyepc"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={2}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.976470588 0 0 0 0 0.321568627 0 0 0 0 0.156862745 0 0 0 1 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M2.301 2.197H8.16v8.42H2.3v-8.42ZM5.23 8.054a1.83 1.83 0 1 0 0-3.66 1.83 1.83 0 0 0 0 3.66Zm0-.732a1.098 1.098 0 1 1 0-2.197 1.098 1.098 0 0 1 0 2.197Zm-3.661 3.66V9.885h7.322v1.099H1.569ZM4.864 0h.732c.202 0 .366.164.366.366v.732H4.498V.366c0-.202.164-.366.366-.366ZM2.31 2.563C2.425 1.334 3.689.366 5.23.366s2.805.968 2.92 2.197H2.31Zm-.375.183a.366.366 0 0 1 0-.732h6.558a.366.366 0 1 1 0 .732H1.935Zm.366 4.538h-.366a.366.366 0 0 1-.366-.366V5.125c0-.202.164-.366.366-.366h.366c.202 0 .366.164.366.366v1.793a.366.366 0 0 1-.366.366Zm6.224 0h-.366a.366.366 0 0 1-.366-.366V5.125c0-.202.163-.366.366-.366h.366c.202 0 .366.164.366.366v1.793a.366.366 0 0 1-.366.366Z"
        id="5kaqpokcm__g09ohquj9d"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M10.759 1a9.698 9.698 0 0 1 6.898 2.874 9.82 9.82 0 0 1 2.86 6.946c0 2.385-1.506 5.3-3.329 7.873C14.858 21.98 11.923 25 10.758 25c-1.164 0-4.098-3.019-6.43-6.307C2.507 16.12 1 13.205 1 10.82a9.82 9.82 0 0 1 2.86-6.946A9.698 9.698 0 0 1 10.76 1Z"
        stroke="url(#5kaqpokcm__c5d6t9hzja)"
        strokeWidth={2}
        fill="url(#5kaqpokcm__4b4lub4d2b)"
      />
      <g transform="translate(5.38 5.267)" fillRule="nonzero">
        <use
          fill="#000"
          filter="url(#5kaqpokcm__ucgztkyepc)"
          xlinkHref="#5kaqpokcm__g09ohquj9d"
        />
        <use fill="#FFE9E1" xlinkHref="#5kaqpokcm__g09ohquj9d" />
      </g>
    </g>
  </svg>
)

const Icon = (props) => {
  const {
    fill = '#0152D9',
    variant = 'transparent',
    size = 20,
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <SvgComponent width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default Icon
